import React from 'react';

type FieldKey = 'civilite' | 'prenomContact' | 'nomContact' | 'telContact' | 'emailContact';

interface ContactInfoSectionProps {
	fields: Record<FieldKey, string>;
	setField: (key: FieldKey, value: string) => void;
	errors: Record<string, string>;
}

function ContactInfoSection({ fields, setField, errors }: ContactInfoSectionProps) {
	return (
		<>
			<div className="mb-4 rounded-lg border border-blue-200 bg-blue-50 p-3">
				<div className="font-semibold text-blue-900">ℹ️ Informations du Contact</div>
				<p className="text-sm text-blue-900/80">Saisissez les informations transmises par le propriétaire lors de l'appel.</p>
			</div>

			<div className="grid gap-4 md:grid-cols-3">
				<div className="md:col-span-1">
					<label className="text-sm font-semibold text-slate-700"><span role="img" aria-label="person">👤</span> Civilité *</label>
					<select value={fields.civilite} onChange={(e) => setField('civilite', e.target.value)} className="w-full rounded-lg border-2 px-3 py-2">
						<option value="">Sélectionnez...</option>
						<option value="M">Monsieur</option>
						<option value="Mme">Madame</option>
						<option value="Mlle">Mademoiselle</option>
					</select>
					{errors.civilite && <div className="mt-1 text-xs text-red-600">{errors.civilite}</div>}
				</div>
				<div className="md:col-span-1">
					<label className="text-sm font-semibold text-slate-700"><span role="img" aria-label="memo">📝</span> Prénom *</label>
					<input value={fields.prenomContact} onChange={(e) => setField('prenomContact', e.target.value)} className="w-full rounded-lg border-2 px-3 py-2" placeholder="Ex: Pierre" />
					{errors.prenomContact && <div className="mt-1 text-xs text-red-600">{errors.prenomContact}</div>}
				</div>
				<div className="md:col-span-1">
					<label className="text-sm font-semibold text-slate-700"><span role="img" aria-label="memo">📝</span> Nom (famille) *</label>
					<input value={fields.nomContact} onChange={(e) => setField('nomContact', e.target.value)} className="w-full rounded-lg border-2 px-3 py-2" placeholder="Ex: DUPONT" />
					{errors.nomContact && <div className="mt-1 text-xs text-red-600">{errors.nomContact}</div>}
				</div>
				<div className="md:col-span-1">
					<label className="text-sm font-semibold text-slate-700"><span role="img" aria-label="telephone">📞</span> Téléphone *</label>
					<input value={fields.telContact} onChange={(e) => setField('telContact', e.target.value)} className="w-full rounded-lg border-2 px-3 py-2" placeholder="Ex: 06 12 34 56 78" />
					{errors.telContact && <div className="mt-1 text-xs text-red-600">{errors.telContact}</div>}
				</div>
				<div className="md:col-span-2">
					<label className="text-sm font-semibold text-slate-700"><span role="img" aria-label="email">📧</span> Email *</label>
					<input value={fields.emailContact} onChange={(e) => setField('emailContact', e.target.value)} className="w-full rounded-lg border-2 px-3 py-2" placeholder="Ex: pierre.dupont@email.fr" />
					{errors.emailContact && <div className="mt-1 text-xs text-red-600">{errors.emailContact}</div>}
				</div>
			</div>
		</>
	);
}

export default ContactInfoSection;


